import Infographic from "#/components/exam-results/infographic";
import ResultsQuestion from "#/components/exam-results/question";
import QuestionsTable from "#/components/exam-results/QuestionsTable";
import { getEducationPackExamResult } from "#/services/rest/gwt/exam-results/exam-results.api";
import type { EducationPackExamQuestionDetail } from "#/services/rest/gwt/exam-results/exam-results.types";
import { useBreakLG } from "@monta/design-system";
import { useParams } from "@monta/router-react";
import { useEffect, useMemo, useState } from "react";
import styles from "./styles.module.scss";

const ResultsPage = () => {
  const params = useParams();
  const examTakingId = Number(params["examTakingId"]);

  const { data } = getEducationPackExamResult.useQuery({
    request: { body: { examTakingId: examTakingId ?? "" } }
  });
  const [details, setDetails] = useState<EducationPackExamQuestionDetail[]>([]);
  const isDesktop = useBreakLG();

  useEffect(() => {
    const parsedDetails = data && JSON.parse(data.questionDetails);
    setDetails(parsedDetails);
  }, [data]);

  const counter = useMemo(() => {
    let correct = 0;
    let unchecked = 0;
    let wrong = 0;

    if (details) {
      details.forEach((question) => {
        if (!question.selectedChoiceOrder) unchecked += 1;
        else if (question.selectedChoiceOrder === question.correctChoiceOrder)
          correct += 1;
        else wrong += 1;
      });
      return {
        correctCount: correct,
        wrongCount: wrong,
        uncheckedCount: unchecked
      };
    }
  }, [details]);

  return (
    <>
      {data && details && (
        <Infographic
          finalMark={data.finalMark}
          correctCount={counter?.correctCount ?? 0}
          wrongCount={counter?.wrongCount ?? 0}
          uncheckedCount={counter?.uncheckedCount ?? 0}
          totalCount={details.length}
          examName={data.examName}
        />
      )}
      <section className={styles["results__details"]}>
        <div className={styles["results__details-header"]}>
          <h2>بررسی سوال به سوال</h2>
          {details && <span>({details.length} سوال)</span>}
        </div>
        <div className={styles["results__details-question"]}>
          {!isDesktop && details
            ? details.map((question) => (
                <ResultsQuestion {...question} key={question.questionId} />
              ))
            : details && <QuestionsTable questions={details} />}
        </div>
      </section>
    </>
  );
};

export default ResultsPage;
